import { deleteBankSource } from 'commons/service/bank/salesData'
import { WriteHook, useMutationManager } from 'state-manager'

export const useBankSourceDelete: WriteHook<number, void> = (opts) =>
  useMutationManager<number, void>(deleteBankSource, opts)
